import loadable from '@loadable/component';

export const ExpertsPage = loadable(/* #__LOADABLE__ */ () => import('./ExpertsPage'));
